'use client';

import { useSyncExternalStore } from 'react';

type DeviceType = 'mobile' | 'tablet' | 'desktop';

interface Breakpoints {
  mobile: number;
  tablet: number;
}

const getDeviceType = (width: number, breakpoints: Breakpoints): DeviceType => {
  if (width < breakpoints.mobile) return 'mobile';
  if (width < breakpoints.tablet) return 'tablet';
  return 'desktop';
};

const subscribe = (callback: () => void): (() => void) => {
  window.addEventListener('resize', callback);
  return () => window.removeEventListener('resize', callback);
};

const useDeviceType = (breakpoints: Breakpoints = { mobile: 768, tablet: 1024 }): DeviceType => {
  const getSnapshot = (): DeviceType => getDeviceType(window.innerWidth, breakpoints);
  const deviceType = useSyncExternalStore(subscribe, getSnapshot, () => 'desktop');

  return deviceType as DeviceType;
};

export default useDeviceType;